/**
 * Fragment de routes du paquet v11-p02-lecteur (vague V11, règle R2 du découpage V4–V11 : un fragment par paquet, le
 * fichier `v11.tsx` de la vague n'est écrit par personne). Composants chargés à la demande, aucun code exécuté au
 * chargement. Routes neuves, aucune route du socle remplacée :
 *  - `/projet/cible-application?projet=…&version=…` → projet-cible-application-lecteur ;
 *  - `/acces-projet/solliciter?espace=…` → dialogue-solliciter-acces ;
 *  - `/acces-projet/annuler?espace=…&sollicitation=…` → dialogue-annuler-sollicitation.
 * Les dialogues prennent `espace` (pas `projet`) comme `projet-acces` de V1 : la porte de la coquille intercepte `?projet=`
 * d'un projet dont on n'est pas membre.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProjetCibleApplicationLecteur = lazy(() => import('../ecrans/v11/lecteur/ProjetCibleApplicationLecteur'))
const DialogueSolliciterAcces = lazy(() => import('../ecrans/v11/lecteur/DialogueSolliciterAcces'))
const DialogueAnnulerSollicitation = lazy(() => import('../ecrans/v11/lecteur/DialogueAnnulerSollicitation'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v11-lecteur',
  routes: [
    { chemin: '/projet/cible-application', element: ecran(ProjetCibleApplicationLecteur) },
    { chemin: '/acces-projet/solliciter', element: ecran(DialogueSolliciterAcces) },
    { chemin: '/acces-projet/annuler', element: ecran(DialogueAnnulerSollicitation) },
  ],
}
